import { useTranslation } from "react-i18next";
import type { Tree } from "../data/types";
import { hasUncertainLocation, wasVisited } from "../data/treeStatus";
import "./TreeStatus.css";

export function TreeStatus({ tree }: { tree: Tree }) {
  const { t } = useTranslation();
  return <span className="tree-statuses">
    {!wasVisited(tree) && <abbr title={t("visit.hint")}>{t("visit.notVisited")}</abbr>}
    {hasUncertainLocation(tree) && <abbr title={t("location.hint")}>{t(tree.location.precision === "unknown" ? "location.unknown" : "location.uncertain")}</abbr>}
  </span>;
}
